import {PreciseGameTimeDomainModel} from "./precise-game-time.domain-model";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {PRECISE_GAME_TIME} from "../../../../core/app/consts";

export class PreciseGameTimeViewModel extends BaseViewModel {
  domainModel: PreciseGameTimeDomainModel;

  get minutes(): Number {
    return this.domainModel.minutes;
  }

  get seconds(): Number {
    return this.domainModel.seconds;
  }

  get autoProgress(): Boolean {
    return this.domainModel.autoProgress;
  }

  get countForward(): Boolean {
    return this.domainModel.clockDirection === PRECISE_GAME_TIME.CLOCK_DIRECTION.forward
  }

  get countBackward(): Boolean {
    return this.domainModel.clockDirection === PRECISE_GAME_TIME.CLOCK_DIRECTION.backward
  }
}
